<template>
<div>
  <van-nav-bar
    title="消息中心"
    id="topbar"
    left-text="返回"
    @click-left="back()"
    style="background-color: #4263EB"
  />


  <div style="margin-top: 55px">

  </div>
  <van-swipe-cell style="width: 100%;margin-top: 5px" v-for="(item,index) in notReadMessageList" :key="index">
    <van-notice-bar  left-icon="info-o" :scrollable="false"   style="height: 44px" @click="showMessage(item.content)">
      {{formatTimestamp(item.sendTime)}} {{item.title}}
    </van-notice-bar>
    <template #right>
      <van-button square text="已读" type="info" class="delete-button" @click="readMessage(item.msgUserRel.id)" />
    </template>
  </van-swipe-cell>

  <van-swipe-cell style="width: 100%;margin-top: 5px" v-for="(item,index) in messageList" :key="index">
    <van-notice-bar color="#1989fa" background="#ecf9ff"  left-icon="info-o" :scrollable="false"   style="height: 44px" @click="showMessage(item.content)">
      {{formatTimestamp(item.sendTime)}} {{item.title}}
    </van-notice-bar>
  </van-swipe-cell>



  <van-popup v-model="show" style="width: 70%;height: 200px">
    <div style="width: 100%;height: 50px;margin-top: 20px;text-align: center;font-size: 16px;font-weight: bold">
      消息内容
    </div>
    <div style="width: 80%;font-size: 14px;text-align: center;margin: 0px auto">
      {{messageContent}}
    </div>
  </van-popup>



</div>
</template>

<script>
import $ from '@/fly'
import { Toast, Dialog, ImagePreview } from 'vant';
import Setting from '@/setting';
import {recMsg,updateMessage} from "@/api/module/message/message";
export default {
  name: "messageList",
  data(){
    return{
      userInfo:{},
      notReadMessageList:[],
      messageList:[],
      pageNum:1,
      pageNumNotRead:1,
      show:false,
      messageContent: '',
      backPath: ''
    }
  },
  mounted() {
    this.backPath = this.$route.params.backPath
    console.log('backPath',this.backPath)
    this.userInfo = JSON.parse(localStorage.getItem('USER'))
    console.log('userInfo',this.userInfo)
    this.getMessageList()


  },
  methods:{
    back(){
      this.$router.push({name: this.backPath})
    },
    showMessage(messageContent){
      this.messageContent = messageContent;
      this.show = true
    },
    readMessage(id){
      updateMessage(id).then(res=>{
        this.getMessageList()
      })
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    //查询未读消息
    getMessageList(){

        recMsg(this.userInfo.userId,this.pageNumNotRead,false).then(res=>{
          this.notReadMessageList=res.rows
        })



      recMsg(this.userInfo.userId,this.pageNum,true).then(ress=>{
        this.messageList = ress.rows
      })


    },

  }
}
</script>

<style scoped>

</style>
